class Controller {
  constructor(Events, $state, Tag, $location, $stateParams, Sections) {
    "ngInject";

    this.Events = Events;
    this.$state = $state;
    this.Tag = Tag;
    this.$location = $location;
    this.$stateParams = $stateParams;

    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;

    this.addItemEvent = this.Events.getAddEvent("tags");
    this.filterEvent = this.Events.getFilterEvent("tags");
    this.paginateEvent = this.Events.getPaginateEvent("tags");
    this.sortEvent = this.Events.getSortEvent("tags");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/tags/tags.controller.js